module.exports = __webpack_public_path__ + "static/media/weight.284ac282.svg";